import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { FormContextProvider } from '../../../context/formContext'
import ModalRegisterToUser from './ModalUserRegister'

export const ModalConfirmation = ({ open, setOpen, setOpenRegister }) => {
  const [userRegister, setUserRegister] = useState('')
  const [openUserModal, setOpenUserModal] = useState(false)

  const handleClose = () => {
    setUserRegister('')
    setOpen(false)
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  const handleConfirm = () => {
    if (userRegister === 'RegisterUser') {
      setOpenUserModal(true)
      handleClose()
    } else {
      setOpenRegister(true)
      handleClose()
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Registro de MIPYME
          </Typography>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                ¿Que tipo de usuario registrará?{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="IsNativeCommunity"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e) => {
                    setUserRegister(e.target.value)
                  }}
                  value={userRegister}
                >
                  <FormControlLabel
                    value="newUser"
                    control={<Radio />}
                    label="Usuario nuevo"
                  />
                  <FormControlLabel
                    value="RegisterUser"
                    control={<Radio />}
                    label="Usuario registrado"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={() => handleClose()}>
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                type="button"
                onClick={() => handleConfirm()}
                // onClick={validateFormStatus}
                disabled={userRegister === ''}
              >
                Confirmar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <FormContextProvider>
        <ModalRegisterToUser open={openUserModal} setOpen={setOpenUserModal} />
      </FormContextProvider>
    </>
  )
}
